module.exports = __webpack_public_path__ + "img/closed-loop-2.eae48563.png";